import { DashboardType } from "../../types/Dashboard/DashboardType";
import api from "../../utils/api";
import { DASHBOARD_URL } from "../../utils/endpoints";

export async function getDashboard(filterValues?: any) {
  try {
    const response = await api.get(DASHBOARD_URL, {
      params: {
        ...filterValues,
      },
    });
    const data: DashboardType = response.data;

    return data;
  } catch (error) {
    throw error;
  }
}
